"use strict";
/**
 * 脱敏工具
 * -----------------------------------------------------------------------------
 * **日志、响应、导出中的敏感字段必须经过本模块处理，不得在调用点手工拼接。**
 * 见 docs/02-domain/07-留存与合规.md §3.2、docs/06-ops/03-观测与审计.md §1.3
 *
 * ⚠️ **姓名不是敏感字段，本模块不提供 `maskName`**（口径见 `权限矩阵.md` §3）。
 * 曾经有过一版 `maskName`，已按业务方裁定删除 —— 理由是可验证的：
 * `Registration.applicantName` 在库里就是**明文列**（只有 `phone` / `idCard` 走密文 + 哈希），
 * 所以在响应里把姓名打码**不构成任何保护**，只会让运营多一步「去 PII 页核对这是不是重名的那个人」。
 * 同理，`redactDeep` 的 `SENSITIVE_KEYS` 也从不包含姓名类键。
 * 需要按「人」核对时，姓名必须是原值。
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.maskIdCard = maskIdCard;
exports.maskPhone = maskPhone;
exports.maskBankAccount = maskBankAccount;
exports.maskBankCard = maskBankCard;
exports.redactDeep = redactDeep;
/** 身份证号脱敏：`110***********1234`（保留前 3 后 4） */
function maskIdCard(idCard) {
    if (!idCard)
        return null;
    const s = String(idCard).trim();
    if (s.length <= 7)
        return '*'.repeat(s.length);
    return `${s.slice(0, 3)}${'*'.repeat(s.length - 7)}${s.slice(-4)}`;
}
/** 手机号脱敏：`138****5678` */
function maskPhone(phone) {
    if (!phone)
        return null;
    const s = String(phone).trim();
    if (s.length < 7)
        return '*'.repeat(s.length);
    return `${s.slice(0, 3)}****${s.slice(-4)}`;
}
/** 银行账号脱敏：仅保留后 4 位 */
function maskBankAccount(account) {
    if (!account)
        return null;
    const s = String(account).replace(/\s/g, '');
    if (s.length <= 4)
        return '*'.repeat(s.length);
    return `${'*'.repeat(s.length - 4)}${s.slice(-4)}`;
}
/**
 * 银行卡号脱敏：`***************6789`（与 `maskBankAccount` 同规则，仅保留后 4 位）。
 * 任务卡 T-15 的命名是 `maskBankCard`，这里作为别名导出 —— 两套名字一个实现，
 * 避免出现第二份「各写各的」脱敏逻辑。
 */
function maskBankCard(cardNo) {
    return maskBankAccount(cardNo);
}
/**
 * 递归脱敏对象中的敏感键。
 * 用于日志与响应裁剪：**不要临时手写键名列表**，统一走此处。
 */
const SENSITIVE_KEYS = [
    'idCard',
    'idCardNo',
    'idCardEncrypted',
    'idCardHash',
    'phone',
    'phoneEncrypted',
    'phoneHash',
    'bankAccount',
    'accountNo',
    'password',
    'passwordHash',
    'token',
    'cookie',
    'authorization',
    'openid',
];
function redactDeep(input) {
    if (input === null || input === undefined)
        return input;
    if (Array.isArray(input))
        return input.map((v) => redactDeep(v));
    if (typeof input === 'object') {
        const out = {};
        for (const [k, v] of Object.entries(input)) {
            out[k] = SENSITIVE_KEYS.includes(k)
                ? '[REDACTED]'
                : redactDeep(v);
        }
        return out;
    }
    return input;
}
//# sourceMappingURL=mask.js.map